export default "__VITE_ASSET__CgbHomjf__"